export const AUTH_TOKEN_KEY_NAME = "auth_token";
export const LOCALE_KEY_NAME = "locale";

export const MAX_TIMED_PEAK_DAY_RECORDS = 6;

export const WEBSOCKET_CONNECT_DELAY = 1000;
export const WEBSOCKET_PING_DELAY = 2000;
export const WEBSOCKET_PING_TIMEOUT_DELAY = 5000;
export const SITE_ID_KEY_NAME = 'site_on_display';
export const ALL_SITES_ID = "-";